export enum CampaignStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Paused = 'PAUSED',
  Draft = 'DRAFT',
  Completed = 'COMPLETED',
}
